import { Link } from "react-router-dom";
import {Leaf} from 'lucide-react';

export default function Footer() {
  const supportedCalculations = [
    "Methane to CO2e",
    "KWh to Carbon",
    "Miles to CO2",
    "Natural Gas to CO2",
    "Air Travel Emissions",
    "Home Energy Footprint",
  ];

  return (
    <footer className="bg-gray-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="bg-[#2E8B57] p-2 rounded-lg">
                <Leaf className="w-5 h-5 text-white" />
              </div>
              <span className="text-white font-semibold">
                GHG Calculator
              </span>
            </div>
            <p className="text-sm text-gray-400">
              User-friendly alternative to the EPA Greenhouse Gas Calculator
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/" className="hover:text-[#2E8B57] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/business" className="hover:text-[#2E8B57] transition-colors">
                  Business Calculator
                </Link>
              </li>
              <li>
                <Link to="/science" className="hover:text-[#2E8B57] transition-colors">
                  Learn the Science
                </Link>
              </li>
              <li>
                <Link to="/lifestyle" className="hover:text-[#2E8B57] transition-colors">
                  Household & Lifestyle
                </Link>
              </li>
            </ul>
          </div>

          {/* Supported Calculations */}
          <div>
            <h3 className="text-white font-semibold mb-4">
              Supported Calculations
            </h3>
            <ul className="space-y-2 text-sm">
              {supportedCalculations.map((calc) => (
                <li key={calc} className="text-gray-400">
                  {calc}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h3 className="text-white font-semibold mb-4">Information</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <a href="#" className="hover:text-[#2E8B57] transition-colors">
                  Methodology
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#2E8B57] transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#2E8B57] transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="hover:text-[#2E8B57] transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-sm text-center text-gray-400">
          <p>
            © {new Date().getFullYear()} GreenhouseGasCalculator.com. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
